/**
 * A pilha de avisos no canto, para quando o painel está à vista.
 *
 * Ver `ganchos/usarAvisosAoVivo.ts` para por que existem dois tipos de
 * aviso e qual aparece quando.
 */

import { useCallback, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { url } from '../api/cliente'
import { usarAvisosAoVivo, type AvisoAoVivo } from '../ganchos/usarAvisosAoVivo'

/* Três, e as mais novas em cima. Com dez, a pilha cobre a tela e o
   alerta passa de aviso a estorvo — e quem está trabalhando fecha tudo
   sem ler, que é o oposto do objetivo. O histórico completo fica em
   Avisos; isto aqui é só "aconteceu agora". */
const NA_PILHA = 3
const SOME_EM_MS = 25000

export function AvisosAoVivo() {
  const [pilha, setPilha] = useState<AvisoAoVivo[]>([])
  const ir = useNavigate()

  const aoChegar = useCallback((a: AvisoAoVivo) => {
    setPilha(p => [a, ...p.filter(x => x.id !== a.id)].slice(0, NA_PILHA))
    /* Some sozinho, porque quem está olhando a tela já viu. O do sistema
       operacional é que fica até alguém dispensar — lá a pessoa pode
       estar em outro programa. */
    setTimeout(() => setPilha(p => p.filter(x => x.id !== a.id)), SOME_EM_MS)
  }, [])

  usarAvisosAoVivo(aoChegar)

  if (!pilha.length) return null

  return (
    <div className="avisos-ao-vivo">
      {pilha.map(a => (
        <button key={a.id} className="aviso-vivo"
                onClick={() => {
                  setPilha(p => p.filter(x => x.id !== a.id))
                  ir('/avisos')
                }}>
          {a.foto && (
            <img src={url(`/imagens/${a.foto}`)} alt="" loading="lazy" />
          )}
          <span className="aviso-vivo-texto">
            <strong>{a.titulo}</strong>
            <span>{a.texto}</span>
          </span>
          <span className="aviso-vivo-x"
                onClick={e => {
                  e.stopPropagation()
                  setPilha(p => p.filter(x => x.id !== a.id))
                }}>✕</span>
        </button>
      ))}
    </div>
  )
}
